import useLocalStorage from '#layers/base/composables/useLocalStorage'

export type IProductTracking = {
  /**
   * Stored as string, but older values may be numbers.
   */
  master_key?: string | number
  item_list_name?: string
  item_list_type?: string
  item_category?: string
  index?: number
}
interface IProductTrackingStorageFormat {
  // key is product ID
  [key: string]: IProductTracking
}

const defaultProductTrackingStore = {}

const { stored, set } = useLocalStorage<IProductTrackingStorageFormat>(
  'productTracking',
  defaultProductTrackingStore,
)
const useProductTrackingLocalStorage = () => {
  const getStoredProductTrackingItem = (
    itemId: string,
  ): IProductTracking | undefined => stored.value?.[itemId]

  const getStoredProductTrackingItemByMasterKey = (
    masterKey: string | number,
  ): IProductTracking | undefined => {
    const normalizedMasterKey = String(masterKey)
    const storedValues = Object.values(stored.value || {})
    return storedValues.find(
      (item) =>
        item.master_key != null &&
        String(item.master_key) === normalizedMasterKey,
    )
  }

  const storeProductTracking = (value: IProductTrackingStorageFormat) => {
    set({
      ...stored.value,
      ...value,
    })
  }

  const deleteProductTrackingItems = (itemIds: string[]) => {
    const storedCopy = { ...stored.value }

    for (let i = 0; i < itemIds.length; i++) {
      const itemId = itemIds[i]
      if (itemId === undefined) {
        continue
      }
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete storedCopy[itemId]
    }

    set(storedCopy)
  }

  return {
    getStoredProductTrackingItem,
    getStoredProductTrackingItemByMasterKey,
    storeProductTracking,
    deleteProductTrackingItems,
  }
}

export default useProductTrackingLocalStorage
